require('./ChannelHeader.scss');

const b = require('app/www/libs/b')('channel-header');

const React = require('react');
const PropTypes = require('prop-types');

const {withReq} = require('app/www/components/contexts/Req');
const {withI18n} = require('app/www/components/contexts/I18n');

const Button_FavoriteChannel = require('app/www/components/blocks/Button/_FavoriteChannel/Button_FavoriteChannel');
const ChannelLogo = require('app/www/components/blocks/ChannelLogo/ChannelLogo');
const Ua = require('app/www/components/blocks/Ua/Ua');

const ChannelHeader = (props) => {
    const {
        id,
        req,
        logo,
        title,
        isFavorite,
        isLayoutColumnsSmall,
        isLayoutColumnsLarge,
    } = props;

    const isSerpApp = req.lib('urlBuilder').isSerpApp;
    const showButtonFavoriteChannel = Ua.displayWidth && !isSerpApp;


    const buttonFavoriteChannelProps = {
        channelId: id,
        isFavorite,
        mods: {
            theme: isLayoutColumnsLarge ? 'ghost' : 'grey',
            size: isLayoutColumnsSmall ? 's' : 'l',
            'only-icon': isLayoutColumnsLarge,
            active: isFavorite,
            header: true,
        },
    };

    const channelLogoProps = {
        mods: {
            size: isLayoutColumnsSmall ? 'm' : 'l',
        },
        logo,
    };

    return (
        <div className={b()}>
            <div className={b('title')}>
                <ChannelLogo className={b('logo')} {...channelLogoProps} />
                <h1 className={b('text')}>{title}</h1>
            </div>
            {showButtonFavoriteChannel && (
                <div className={b('buttons')}>
                    <Button_FavoriteChannel {...buttonFavoriteChannelProps} />
                </div>
            )}
        </div>
    );
};

ChannelHeader.propTypes = {
    id: PropTypes.number.isRequired,
    logo: PropTypes.object,
    title: PropTypes.string.isRequired,
    isFavorite: PropTypes.bool,
};

module.exports = withReq(withI18n(ChannelHeader));
